<template>
  <div>
    <template v-if="proprietariosNaoParticipantes.length > 0">
      <v-alert color="primary" text class="mx-4 px-5 text-subtitle-1 font-weight-bold" dense>
        <p class="my-4 ml-3">
          <v-icon color="primary" class="mr-2">ph-warning-circle</v-icon>
          Existem Proprietários de Garantias que não foram cadastrados.<br/>
          <span class="ml-9">Por gentileza, realizar o cadastro para os Participantes abaixo:</span>
        </p>
        <v-row class="text-body-1 font-weight-regular" v-for="(item,i) in proprietariosNaoParticipantes" :key="i">
          <v-col class="align-center">
            {{ item.DocumentoFederalProprietario }} - {{ item.NomeProprietario }}
          </v-col>
          <v-col class="d-flex justify-end">
            <v-btn outlined color="primary" small @click="openFormulario(item.DocumentoFederalProprietario, item.NomeProprietario)">Cadastrar</v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </template>
    <core-grid ref="grid" :onRead="onRead" :schema="schema" mobile-breakpoint="0" modal flat :hide-all-options="resumo"
               :hide-default-footer="resumo" grid-role="ListPropostaDocumento">
      <template v-slot:[`item.TipoDocumento`]="{ item }">
        <v-icon class="mr-2" size="dense" @click="downloadDocumento(item)">fas fa-file-download</v-icon>
        <a @click="downloadDocumento(item)"> {{ $param.ListaDocumentoProposta.find(p => p.value === item.TipoDocumento)?.text ?? item.TipoDocumentoDescricao }}</a>
      </template>
    </core-grid>
    <PropostaAvalistaEdit ref="editar" :proposta="value" @close="response"></PropostaAvalistaEdit>
  </div>
</template>

<script>
export default {
  components: {
    PropostaAvalistaEdit: () => import('./PropostaAvalistaEdit')
  },
  props: {
    resumo: { type: Boolean, default: false },
    value: null
  },
  data () {
    return {
      schema: [
        { value: 'DocumentoFederal', text: 'Documento', format: 'documento' },
        { value: 'Nome', text: 'Nome' }
      ],
      proprietariosNaoParticipantes: []
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        return this.$emit('input', value)
      }
    }
  },
  methods: {
    onRead: function (options) {
      const th = this
      const dto = {
        parameters: [
          { name: 'CodigoProposta', value: th.value.Codigo }
        ]
      }
      th.$api.Multiplo.ListPropostaAvalista(dto).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          options.success(response.Data)
          th.validaProprietario()
        }
      })
    },
    submit (callback) {
      const th = this
      if (th.model.Cliente.TipoPessoa === th.$aux.TipoPessoaEnum.PJ) {
        const dtoParticipantes = {
          parameters: [
            { name: 'CodigoProposta', value: th.model.Codigo }
          ]
        }
        th.$api.Multiplo.ListPropostaAvalista(dtoParticipantes).then(function (listAvalistas) {
          if (th.$api.UI.PostLoadData(listAvalistas, true)) {
            const responseAvalista = listAvalistas.Data
            if (th.model.Cliente.TipoPessoa === th.$aux.TipoPessoaEnum.PJ && responseAvalista.length === 0) {
              th.$api.UI.ShowError(th.$getErrorMessage('form').title, th.$getErrorMessage('avalista').message)
            } else {
              callback()
            }
          }
        })
      } else {
        callback()
      }
    },
    excluir (current) {
      const th = this
      if (current) {
        const dto = {
          guidID: current.Codigo
        }
        th.$api.Multiplo.RemovePropostaAvalista(dto).then(function (data) {
          if (th.$api.UI.PostLoadData(data, true)) {
            th.refresh()
          }
        })
      }
    },
    refresh () {
      this.$refs.grid.refresh()
    },
    response (data) {
      if (data) {
        this.refresh()
      }
    },
    openFormulario (documento, nome) {
      this.$refs.editar.openModal(null, nome, documento)
    },
    validaProprietario () {
      const th = this
      const dtoGarantia = { parameters: [{ name: 'CodigoProposta', value: th.value.Codigo }] }
      th.$set(th, 'proprietariosNaoParticipantes', [])
      th.$api.Multiplo.ListPropostaGarantiaBem(dtoGarantia).then(async function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          const garantias = response.Data
          const dto = {
            parameters: [
              { name: 'CodigoProposta', value: th.value.Codigo }
            ]
          }
          th.$api.Multiplo.ListPropostaAvalista(dto).then(function (response) {
            if (th.$api.UI.PostLoadData(response, true)) {
              garantias.forEach(p => {
                if (!response.Data.some(l => l.DocumentoFederal === th.$api.UI.Format.SomenteNumeros(p.DocumentoFederalProprietario)) &&
                p.DocumentoFederalProprietario !== th.value.Cliente.DocumentoFederal &&
                !th.proprietariosNaoParticipantes.some(item => item.DocumentoFederalProprietario === p.DocumentoFederalProprietario)) { th.proprietariosNaoParticipantes.push(p) }
              })
            }
          })
        }
      })
    },
    load () {
      this.validaProprietario()
    }
  },
}
</script>
